// builder-components.ts
import { Builder } from '@builder.io/react';

import { UccModalContentMultipleOptions } from './modal-content-multiple-options';

Builder.registerComponent(UccModalContentMultipleOptions, {
  name: 'UccModalContentMultipleOptions',
  inputs: [
    {
      name: 'showModalInEditor',
      type: 'boolean',
      defaultValue: false,
      helperText:
        'Only used in Builder editing mode to show/hide modal preview.',
    },
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg', 'webp'],
    },
    {
      name: 'heading',
      type: 'text',
      helperText:
        'Use {partner_name} to insert the partner name in the heading.',
    },
    { name: 'partnerName', type: 'text' },
    {
      name: 'buttonText',
      type: 'string',
      helperText:
        'Used when there is no user phone for the "Connect me" feature. Defaults to "Start Call!"',
      defaultValue: 'Start Call!',
    },
  ],
  noWrap: true,
});
